export default "__VITE_ASSET__DsfxRFwG__"